import PatientPanel from './PatientPanel';

export default PatientPanel;
